import { browserHistory } from 'common/utils/browserHistory';
import querystring from 'query-string';
import { DEFAULT_RECORD_TYPE, DEFAULT_SEARCH_SCOPE } from 'src/components/Search/constants';

function goToSearchIndex({
  query,
  scope = DEFAULT_SEARCH_SCOPE,
  model = DEFAULT_RECORD_TYPE,
  page = 1,
}) {
  const searchObj = {
    q: query,
    model,
    page,
    scope,
  };

  browserHistory.push({
    pathname: '/search',
    search: `?${querystring.stringify(searchObj)}`,
  });
}

export default goToSearchIndex;
